module.exports = __webpack_public_path__ + "static/media/robot.d39cce80.png";